import { Component, OnInit } from '@angular/core';
import { CRAUSEL,IMAGE } from 'src/app/config';
import { ApiService } from './../../../api.service';
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    
})
export class HomeComponent implements OnInit {
  slider_imgs: any;
  exclusive: any;
  mostselling: any;
  events: any;
  info:any;
  url: any;
  manufacturerurl:any;
  manufacturer: any;
  loader:boolean;
  page:boolean;
  slideConfig = {
    "slidesToShow": 4,
    "slidesToScroll": 1,
    "dots": false,
    "infinite": true,
    "autoplay": true,
    "arrows": false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  };
  event: any;
  product: string;
  manufacture: string;
  price:any;
  categoryBanner:any = [];
  subCategoryBanner:any = [];
  subSubCategoryBanner:any = [];
  constructor(private api: ApiService) {
    this.api.Get(CRAUSEL).then(data => {
      this.categoryBanner = [];
      this.subCategoryBanner = [];
      this.subSubCategoryBanner = [];
      this.page=true;
    this.loader=false;
      this.info = this.api.getUserInfo();
      data['body'].forEach(childObj => {
        if (childObj.category === 'app_banners') {
          this.slider_imgs = childObj['app_banners'].filter(slide => slide.place === 'Website');
        }
        else if(childObj.category === 'category_banners')
        {
          this.categoryBanner = childObj['category_banners'].filter(slide => slide.place === 'Website');
        }
        else if(childObj.category === 'subcategory_banners')
        {
          this.subCategoryBanner = childObj['subcategory_banners'].filter(slide => slide.place === 'Website');
        }
        else if(childObj.category === 'subsubcategory_banners')
        {
          this.subSubCategoryBanner = childObj['subsubcategory_banners'].filter(slide => slide.place === 'Website');
        }
        else if (childObj.category === 'exclusive_banners') {
          this.exclusive = childObj['exclusive_banners'].filter(slide => slide.place === 'Website');
        }
        else if (childObj.category === 'product') {
          this.mostselling = childObj['product'];
          this.price = childObj['price'];
          console.log(this.mostselling)
        }
        else if (childObj.category === 'events') {
          this.events = childObj['events']
        }
        else if (childObj.category === 'manufacture') {
          this.manufacturer = childObj['manufacture'];
        }
     });
     this.exclusive.forEach(element => {
      element.image = element.image.replace(/ /g, "%20");
      element.image = element.image.replace(/\(/g, "%28");
      element.image = element.image.replace(/\)/g, "%29");
      console.log(element.image);
    });
      this.url = IMAGE+"banner/";
      this.event = IMAGE+"events/";
      this.product = IMAGE+"product/";
      this.manufacture = IMAGE+"manufacture/";
    }).catch(d=>{
      console.log(d);
    });
  }

  ngOnInit() {
    this.loader=true;
    this.page=false;
  }

}
